import { Record } from 'immutable';

const PaymentRequestActionDataRecord = Record({
  email: null,
  reason: null,
  details: null
});

export class PaymentRequestActionData extends PaymentRequestActionDataRecord {
  email: string;
  reason: string;
  details: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/payment-request-action-data.ts